import Moment from "moment";

export const DATE_FORMAT = "YYYY-MM-DD";

/**
 * Timezone is NOT important because it is only a date
 */
export function displayDate(dateString) {
    return Moment(dateString).format(DATE_FORMAT);
}
